<template>
  <section class="ufw-workspace">
    <table-toolbar :search.sync="search" :show-refresh="true" :show-export="true" :show-column-settings="true" :columns="columnOptions" :visible-columns.sync="visibleColumns" :default-columns="defaultColumns" :fixed-columns="['# ID']" @refresh="initFetch" @export="handleExport">
      <template slot="left">
        <el-popconfirm icon="el-icon-warning" title="确定要立即重载节点吗？该操作会调用后端重载接口。" @confirm="handleUfwReload">
          <el-button slot="reference" type="warning" size="small" icon="el-icon-warning-outline" class="btn-reload">重载节点</el-button>
        </el-popconfirm>
      </template>
    </table-toolbar>
    <!-- 顶部节点分组选择卡片 -->
    <div class="box filter-card">
      <div class="section-header">
        <span class="section-title">Ufw 节点内存</span>
      </div>
      <!-- 节点分组 Tab -->
      <el-tabs v-model="tabNodeGroup" @tab-click="handleTabNodeGroupClick" class="node-group-tabs">
        <el-tab-pane
          :label="item.groupKey"
          :name="item.groupKey"
          v-for="(item, i) in groupNodes"
          :key="i"
        ></el-tab-pane>
      </el-tabs>

      <div class="node-control-row" v-if="nodeOption.length > 0">
        <div class="node-select-area">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            class="check-all-box"
          >全选节点</el-checkbox>
          <el-checkbox-group
            v-model="nodeList"
            @change="handleCheckedCitiesChange"
            class="node-checkbox-group"
          >
            <el-checkbox v-for="item in nodeOption" :label="item" :key="item">
              <span class="node-ip-text">{{ item }}</span>
            </el-checkbox>
          </el-checkbox-group>
        </div>
      </div>
    </div>

    <!-- 内容查看卡片 -->
    <div class="box table-card">
      <div class="card-header-bar">
        <!-- 单节点选择 -->
        <div class="node-radio-row">
          <span class="filter-label">查看节点：</span>
          <template v-for="(item, index) in nodeOption">
            <el-radio v-model="nodeHost" :label="item" :key="index" @input="onNodeInput" class="node-radio">{{ item }}</el-radio>
          </template>
        </div>
      </div>

      <!-- 作用域 & 类型选择区 -->
      <div class="scope-select-area">
        <el-tabs v-model="scopeType" @tab-click="onTabsClick" class="scope-tabs">
          <el-tab-pane
            v-for="(item, index) in scopeOption"
            :key="index"
            :name="item.value"
            :label="item.label"
          >
          </el-tab-pane>
        </el-tabs>

        <div class="ufw-type-row">
          <span class="filter-label">名单类型：</span>
          <template v-for="(item, index) in ufwOption">
            <el-radio v-model="ufwType" :label="item.value" :key="index" class="ufw-radio">
              {{ item.label }}
            </el-radio>
          </template>
          <el-button type="primary" size="small" @click="onUfwSearch()" class="btn-search">查看数据</el-button>
        </div>
      </div>

      <!-- 数据展示表格 -->
      <table-page :loading="loading" :empty="filteredTableData.length === 0" :show-top-pagination="false" :show-bottom-pagination="false" @retry="onUfwSearch">
        <el-table
          :data="filteredTableData"
          style="width: 100%"
          stripe
          class="premium-table"
        >
          <!-- ID列 -->
          <el-table-column key="col-id" prop="id" width="90" fixed="left">
            <template slot="header">
              <span class="premium-header-title"><span class="header-icon-hash">#</span> ID</span>
            </template>
            <template slot-scope="scope">
              <span class="cell-id">{{ scope.row.id }}</span>
            </template>
          </el-table-column>

          <!-- appId 列 -->
          <el-table-column v-if="visibleColumns.includes('appId')" key="col-appId" prop="appId" min-width="110">
            <template slot="header">
              <span class="premium-header-title">appId</span>
            </template>
            <template slot-scope="scope">
              <span class="cell-id">{{ scope.row.appId }}</span>
            </template>
          </el-table-column>

          <!-- 是否开启列 -->
          <el-table-column v-if="visibleColumns.includes('open')" key="col-open" prop="open" width="105" align="center">
            <template slot="header">
              <span class="premium-header-title">是否开启</span>
            </template>
            <template slot-scope="scope">
              <span :class="['status-dot-badge', scope.row.open ? 'online' : 'closed']">
                <span class="dot"></span>
                {{ scope.row.open ? '是' : '否' }}
              </span>
            </template>
          </el-table-column>

          <!-- 规则类型列 -->
          <el-table-column v-if="visibleColumns.includes('ruleType')" key="col-ruleType" prop="ruleType" width="115" align="center">
            <template slot="header">
              <span class="premium-header-title">规则类型</span>
            </template>
            <template slot-scope="scope">
              <el-tag :type="getRuleTypeTag(scope.row.ruleType)" size="small" class="rule-type-tag">
                {{ getRuleTypeLabel(scope.row.ruleType) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 作用域列 -->
          <el-table-column v-if="visibleColumns.includes('scopeType')" key="col-scopeType" prop="scopeType" width="115" align="center">
            <template slot="header">
              <span class="premium-header-title">作用域</span>
            </template>
            <template slot-scope="scope">
              <el-tag :type="getScopeTypeTag(scope.row.scopeType)" size="small" class="scope-type-tag">
                {{ getScopeTypeLabel(scope.row.scopeType) }}
              </el-tag>
            </template>
          </el-table-column>

          <!-- 规则列 -->
          <el-table-column v-if="visibleColumns.includes('ruleKey')" key="col-ruleKey" prop="ruleKey" min-width="220" show-overflow-tooltip>
            <template slot="header">
              <span class="premium-header-title">规则</span>
            </template>
            <template slot-scope="scope">
              <span class="cell-text-main">{{ scope.row.ruleKey }}</span>
            </template>
          </el-table-column>

          <!-- 原因列 -->
          <el-table-column v-if="visibleColumns.includes('reason')" key="col-reason" prop="reason" min-width="180" show-overflow-tooltip>
            <template slot="header">
              <span class="premium-header-title">原因</span>
            </template>
            <template slot-scope="scope">
              <span class="cell-text-gray">{{ scope.row.reason }}</span>
            </template>
          </el-table-column>

          <!-- 是否过期列 -->
          <el-table-column v-if="visibleColumns.includes('expired')" key="col-expired" prop="expired" width="105" align="center">
            <template slot="header">
              <span class="premium-header-title">是否过期</span>
            </template>
            <template slot-scope="scope">
              <span :class="['status-dot-badge', scope.row.expired ? 'closed' : 'online']">
                <span class="dot"></span>
                {{ scope.row.expired ? '是' : '否' }}
              </span>
            </template>
          </el-table-column>

          <!-- 创建时间 -->
          <el-table-column v-if="visibleColumns.includes('createdAt')" key="col-createdAt" prop="createdAt" width="165">
            <template slot="header">
              <span class="premium-header-title">创建时间</span>
            </template>
            <template slot-scope="scope">
              <span class="cell-text-gray">{{ scope.row.createdAt }}</span>
            </template>
          </el-table-column>

          <!-- 更新时间 -->
          <el-table-column v-if="visibleColumns.includes('updatedAt')" key="col-updatedAt" prop="updatedAt" width="165">
            <template slot="header">
              <span class="premium-header-title">更新时间</span>
            </template>
            <template slot-scope="scope">
              <span class="cell-text-gray">{{ scope.row.updatedAt }}</span>
            </template>
          </el-table-column>

          <!-- 过期时间 -->
          <el-table-column v-if="visibleColumns.includes('expiredTime')" key="col-expiredTime" prop="expiredTime" width="165">
            <template slot="header">
              <span class="premium-header-title">过期时间</span>
            </template>
            <template slot-scope="scope">
              <span class="cell-text-gray">{{ scope.row.expiredTime }}</span>
            </template>
          </el-table-column>
        </el-table>
      </table-page>
    </div>
  </section>
</template>

<script>
import api from '@/api/channel'
import { column } from './table'
import TableToolbar from '@/components/TableToolbar/index.vue'
import TablePage from '@/components/TablePage/index.vue'
import * as XLSX from 'xlsx'

export default {
  name: 'ufwIndex',
  components: {
    TableToolbar,
    TablePage
  },
  data: function () {
    return {
      radio: 1,
      tabNodeGroup: '',
      groupNodes: [],
      nodeOption: [],
      nodeList: [],
      nodeHost: '',
      checkAll: true, // 全选
      isIndeterminate: false,
      tableData: [],
      search: '',
      loading: false,
      visibleColumns: column.filter(item => item.value !== 'id').map(item => item.value),
      scopeType: '1',
      scopeOption: [
        { id: 1, label: '封禁', value: '1' },
        { id: 2, label: '充值', value: '2' },
        { id: 3, label: '注册', value: '3' }
      ],
      ufwType: '1',
      ufwList: {}
    }
  },
  computed: {
    appId () {
      return this.$store.getters.appId
    },
    columnOptions () {
      return column.filter(item => item.value !== 'id').map(item => ({ prop: item.value, label: item.label }))
    },
    defaultColumns () {
      return column.filter(item => item.value !== 'id').map(item => item.value)
    },
    filteredTableData () {
      const keyword = this.search.trim().toLowerCase()
      if (!keyword) return this.tableData
      return this.tableData.filter(row => Object.keys(row).some(key => String(row[key]).toLowerCase().includes(keyword)))
    },
    ufwOption () {
      return [
        { id: 1, label: '黑名单', value: '1', request: api.ufwBlacklists },
        { id: 3, label: '白名单', value: '3', request: api.ufwWhitelists }
      ]
    }
  },
  mounted: function () {
    this.initFetch()
  },
  methods: {
    initFetch () {
      this.loading = true
      this.groupNodes = []
      api.getNodeList({ appId: this.appId, format: 'group' }).then(res => {
        if (res.length <= 0) {
          return
        }
        this.groupNodes = res
        const gn = res.find(d => d.selected) || res[0]
        this.tabNodeGroup = gn.groupKey
        this.nodeOption = gn.nodes
        this.nodeHost = gn.nodes[0]
        this.handleCheckAllChange(true)
      }).finally(() => {
        this.loading = false
      })
      this.channelOptions = []
      api.getChannelData(this.appId).then(res => {
        this.channelOptions = Object.assign([], res)
      })
    },
    // 节点列表页签切换
    handleTabNodeGroupClick () {
      const gn = this.groupNodes.find(d => d.groupKey === this.tabNodeGroup) || this.groupNodes[0]
      this.nodeOption = gn.nodes
      this.nodeHost = gn.nodes[0]
      this.handleCheckAllChange(true)
    },
    // 全选
    handleCheckAllChange (val) {
      this.nodeList = val ? this.nodeOption : []
      this.isIndeterminate = false
    },
    handleCheckedCitiesChange (value) {
      const checkedCount = value.length
      this.checkAll = checkedCount === this.nodeOption.length
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.nodeOption.length
      this.visible = false
    },
    handleUfwReload () {
      if (!this.nodeList.length) {
        return this.$message.info('请选择节点')
      }
      const requests = this.nodeList.map(item => {
        return api.ufwReload({ host: item })
      })
      Promise.all(requests).then(() => {
        this.tableData = []
        this.$message.success('重载节点成功')
      }).catch(() => {
        this.$message.error('重载节点失败')
      })
    },
    onUfwSearch (item) {
      let target = item
      if (!target) {
        target = this.ufwOption.find(item => +this.ufwType === +item.value)
      }
      this.loading = true
      target.request({ host: this.nodeHost, type: +this.scopeType }).then(res => {
        this.tableData = res.data ?? []
      }).finally(() => {
        this.loading = false
      })
    },
    onNodeInput () {
    },
    onTabsClick () {
    },
    handleExport () {
      const worksheet = XLSX.utils.json_to_sheet(this.filteredTableData)
      const workbook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workbook, worksheet, 'UFW节点内存')
      XLSX.writeFile(workbook, `UFW节点内存-${this.$moment().format('YYYYMMDDHHmmss')}.xlsx`)
    },
    getScopeTypeLabel (type) {
      const map = { 1: '封禁', 2: '充值', 3: '注册' }
      return map[type] || type
    },
    getScopeTypeTag (type) {
      const map = { 1: 'danger', 2: 'success', 3: 'warning' }
      return map[type] || 'info'
    },
    getRuleTypeLabel (type) {
      const map = { 1: '用户', 2: 'ip', 3: '设备' }
      return map[type] || type
    },
    getRuleTypeTag (type) {
      const map = { 1: 'primary', 2: 'info', 3: 'warning' }
      return map[type] || 'info'
    }
  }
}
</script>

<style scoped>
.ufw-workspace {
  padding: 16px 24px;
}

/* 顶部节点控制卡片 */
.filter-card {
  margin-top: 0 !important;
  margin-bottom: 20px;
  padding: 20px 24px;
  border-radius: var(--border-radius-card);
  background: var(--bg-card);
  border: 1px solid #E2E8F0;
  box-shadow: var(--shadow-base);
}

.section-header {
  margin-bottom: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-main);
}

/* 节点分组 Tabs */
.node-group-tabs {
  margin-bottom: 16px;
}

.node-group-tabs :deep(.el-tabs__header) {
  margin-bottom: 0;
}

.node-group-tabs :deep(.el-tabs__item) {
  font-weight: 600;
  color: #64748B;
}

.node-group-tabs :deep(.el-tabs__item.is-active) {
  color: var(--primary-color);
}

.node-group-tabs :deep(.el-tabs__active-bar) {
  background-color: var(--primary-color);
}

/* 节点选择控制行 */
.node-control-row {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding-top: 12px;
  border-top: 1px solid var(--border-color);
}

.node-select-area {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  flex: 1;
}

.check-all-box {
  font-weight: 600;
  color: var(--text-main);
  flex-shrink: 0;
}

.node-checkbox-group {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.node-checkbox-group :deep(.el-checkbox) {
  margin-right: 0;
}

.node-ip-text {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-muted);
}

.node-action-area {
  flex-shrink: 0;
}

.btn-reload {
  border-radius: 8px !important;
  font-weight: 600 !important;
  height: 32px;
  padding: 0 16px;
  background-color: var(--bg-reload) !important;
  border-color: var(--border-reload) !important;
  color: var(--text-reload) !important;
}

.btn-reload:hover,
.btn-reload:focus {
  background-color: var(--bg-reload-hover) !important;
  border-color: var(--border-reload-hover) !important;
  color: var(--text-reload-hover) !important;
}

/* 表格卡片 */
.table-card {
  padding: 20px 24px;
  border-radius: var(--border-radius-card);
  background-color: var(--bg-card);
  border: 1px solid var(--border-color);
  box-shadow: var(--shadow-base);
}

/* 节点单选行 */
.card-header-bar {
  margin-bottom: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border-color);
}

.node-radio-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.filter-label {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-main);
  flex-shrink: 0;
}

.node-radio {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 12px;
  font-weight: 600;
  color: var(--text-main);
}

/* 作用域选择区 */
.scope-select-area {
  margin-bottom: 20px;
}

.scope-tabs {
  margin-bottom: 12px;
}

.scope-tabs :deep(.el-tabs__item) {
  font-weight: 600;
  color: var(--text-muted);
}

.scope-tabs :deep(.el-tabs__item.is-active) {
  color: var(--primary-color);
}

.scope-tabs :deep(.el-tabs__active-bar) {
  background-color: var(--primary-color);
}

.scope-tabs :deep(.el-tabs__nav-wrap::after) {
  background-color: var(--border-color);
}

.ufw-type-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
}

.ufw-radio {
  font-weight: 600;
  color: var(--text-main);
}

.btn-search {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
  border-radius: 8px !important;
}

.btn-search:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

/* 数据表格区 */
.table-content-area {
  margin-top: 4px;
}

.premium-header-title {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-weight: 700;
  color: inherit;
}

.header-icon-hash {
  font-family: Menlo, Monaco, Consolas, monospace;
  font-size: 13.5px;
  font-weight: 900;
  color: inherit;
}

.cell-id {
  font-family: Menlo, Monaco, Consolas, "Courier New", monospace !important;
  font-size: 12.5px !important;
  font-weight: 600;
  color: var(--text-muted);
}

.premium-table {
  border-radius: 8px;
  overflow: hidden;
  border: none !important;
  font-size: 13px !important;
  color: var(--text-main) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", sans-serif !important;
}

.premium-table::before {
  display: none !important;
}

.premium-table :deep(.el-table__header-wrapper) th,
.premium-table :deep(.el-table__fixed-header-wrapper) th,
.premium-table :deep(.el-table__fixed-right-header-wrapper) th,
.premium-table :deep(th.el-table__fixed-column) {
  background-color: var(--bg-page) !important;
  color: var(--text-muted) !important;
  font-weight: 700 !important;
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-color) !important;
}

.premium-table :deep(.el-table__row) td {
  padding: 12px 0 !important;
  border-bottom: 1px solid var(--border-light) !important;
}

.premium-table :deep(.el-table__row) {
  transition: background-color 0.2s ease;
}

.premium-table :deep(.el-table__row:hover) td {
  background-color: var(--bg-hover) !important;
}

.premium-table :deep(.el-table__body tr.hover-row > td),
.premium-table :deep(.el-table__body tr.hover-row.current-row > td),
.premium-table :deep(.el-table__body tr.hover-row.el-table__row--striped > td) {
  background-color: var(--bg-hover) !important;
}

/* 深色模式精修适配 */
html.dark .filter-card,
html.dark .table-card {
  background-color: var(--bg-card) !important;
  border-color: var(--border-color) !important;
}

html.dark .section-title {
  color: var(--text-main) !important;
}

html.dark .node-group-tabs :deep(.el-tabs__item),
html.dark .scope-tabs :deep(.el-tabs__item) {
  color: var(--text-muted) !important;
}

html.dark .node-group-tabs :deep(.el-tabs__item.is-active),
html.dark .scope-tabs :deep(.el-tabs__item.is-active) {
  color: var(--primary-color) !important;
}

html.dark .node-group-tabs :deep(.el-tabs__nav-wrap::after),
html.dark .scope-tabs :deep(.el-tabs__nav-wrap::after) {
  background-color: var(--border-color) !important;
}

html.dark .node-radio :deep(.el-radio__label),
html.dark .ufw-radio :deep(.el-radio__label) {
  color: var(--text-main) !important;
}

html.dark .node-radio :deep(.el-radio__inner),
html.dark .ufw-radio :deep(.el-radio__inner) {
  background-color: var(--bg-page) !important;
  border-color: var(--border-color) !important;
}

html.dark .node-radio.is-checked :deep(.el-radio__inner),
html.dark .ufw-radio.is-checked :deep(.el-radio__inner) {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
}
</style>
